<h1>NOTIZIE</h1>
<div *ngFor="let notizia of notizie" class="notizie-container">
	<mat-card class="notizia">
		<mat-card-header>
			<mat-card-title>{{ notizia.titolo }}</mat-card-title>
			<mat-card-subtitle>{{ notizia.sottotitolo }}</mat-card-subtitle>
			<mat-card-subtitle>{{ notizia.dataPubblicazione }}</mat-card-subtitle>
		</mat-card-header>
		<div *ngIf="notizia.immagine" class="img-container">
			<img mat-card-image [src]="notizia.immagine" alt="Immagine di {{ notizia.titolo }}" class="card-img-right">
		</div>
		<mat-card-content>
			{{ notizia.contenuto }}
		</mat-card-content>
		<mat-card-actions *ngIf="notizia.links && notizia.links.length > 0" class="links-container">
			<ng-container *ngFor="let link of notizia.links">
				<a mat-button class="news-btn" *ngIf="link.url" [href]="link.url" target="_blank">{{ link.nome }}</a>
				<a mat-button  class="news-btn" *ngIf="link.routerLink" [routerLink]="link.routerLink">{{ link.nome }}</a>
			</ng-container>
		</mat-card-actions>
	</mat-card>
</div>